import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import * as $ from 'jquery';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
@Component({
  selector: 'app-advanced-search-einvoice-portal',
  templateUrl: './advanced-search-einvoice-portal.component.html',
  styleUrls: ['./advanced-search-einvoice-portal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvancedSearchEInvoicePortalComponent implements OnInit {
  @Input() id: string;
  @Output() advancedSearch = new EventEmitter<any>();
  @Output() resetEmitter = new EventEmitter<boolean>();

  searchForm: FormGroup;
  selectedToggle: string = 'byDateAmount';
  isAdvanced: boolean;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initializeForm();
    this.isAdvanced = false;

    $(document).mouseup(ev => {
      const container = $(`#${this.id}`);
      const calendar = $('mat-calendar');
      const matOption = $('mat-option');
      const backdrop = $('.cdk-overlay-backdrop');
      if (!matOption.is(ev.target) && !calendar.is(ev.target) && !container.is(ev.target) && !backdrop.is(ev.target)
        && matOption.has(ev.target).length === 0
        && container.has(ev.target).length === 0
        && calendar.has(ev.target).length === 0
        && backdrop.has(ev.target).length === 0) {
        container.hide('fast', 'swing', c => {
          this.isAdvanced = false;
        });
      }
    });
  }

  initializeForm(): void {
    this.searchForm = this.fb.group({
      invoiceNo: ['', Validators.required],
      amount: [''],
      transactionDate: [''],
      pin: [''],
    });

    this.updateFormValidators();
  }

  searchToggle() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      container.show('fast', 'swing', c => this.isAdvanced = true);
    }
  }

  updateFormValidators(): void {
    if (this.selectedToggle === 'byDateAmount') {
      this.searchForm.get('amount')?.setValidators([Validators.required]);
      this.searchForm.get('transactionDate')?.setValidators([Validators.required]);
      this.searchForm.get('pin')?.clearValidators();
    } else if (this.selectedToggle === 'byPin') {
      this.searchForm.get('pin')?.setValidators([Validators.required]);
      this.searchForm.get('amount')?.clearValidators();
      this.searchForm.get('transactionDate')?.clearValidators();
    }
    this.searchForm.get('amount')?.updateValueAndValidity();
    this.searchForm.get('transactionDate')?.updateValueAndValidity();
    this.searchForm.get('pin')?.updateValueAndValidity();
  }

  onAdvancedSearch(): void {
    const container = $(`#${this.id}`);
    container.hide('fast', 'swing', c => {
      this.isAdvanced = false;
    });
    if (this.searchForm.valid) {
      const payload = this.selectedToggle === 'byDateAmount'
        ? {
            invoiceNo: this.searchForm.get('invoiceNo')?.value,
            amount: this.searchForm.get('amount')?.value,
            transactionDate: this.searchForm.get('transactionDate')?.value,
          }
        : {
            invoiceNo: this.searchForm.get('invoiceNo')?.value,
            pin: this.searchForm.get('pin')?.value,
          };

      this.advancedSearch.emit(payload);
    }
  }

  resetForm(): void {
    this.resetEmitter.emit(true);
    this.searchForm.reset();
    this.selectedToggle = 'byDateAmount';
    this.updateFormValidators();
  }
}
